import React, { useEffect, useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Backdrop from '../../composer/backdrop';
import './withBackdrop.scss';
import useModalManager from '../../custom-hook/use-modal-manager';

/* eslint-disable react/jsx-props-no-spreading */
const withBackdrop = (View) => {
  const BackdroppedView = ({
    open: openProp,
    onBackdropClick,
    showClose,
    onClose,
    onCloseIconClick,
    drawer,
    ...props
  }) => {
    const [registerModal, unregisterModal] = useModalManager();
    const modalId = useRef(null);
    const [openState, setOpenState] = useState(openProp);

    useEffect(() => {
      // to prevent rerenders from parent component
      if (openProp !== openState) {
        setOpenState(openProp);
      }
    }, [openProp]);

    useEffect(() => {
      if (openState) {
        const callback = () => onClose();
        const id = registerModal(callback);
        modalId.current = id;
      } else {
        unregisterModal(modalId.current);
      }

      return () => unregisterModal(modalId.current);
    }, [openState]);

    const handleBackdropClick = () => {
      onBackdropClick();
      onClose();
    };
    return ReactDOM.createPortal(
      <Backdrop open={openState} drawer={drawer} onBackdropClick={handleBackdropClick}>
        <View
          ref={props.passRef}
          {...props}
          showClose={showClose}
          onClose={onClose}
        />
      </Backdrop>,
      document.getElementById('modal-root'),
    );
  };

  BackdroppedView.propTypes = {
    open: PropTypes.bool,
    showClose: PropTypes.bool,
    onBackdropClick: PropTypes.func,
    onClose: PropTypes.func,
  };

  BackdroppedView.defaultProps = {
    open: false,
    showClose: true,
    onBackdropClick: () => {},
    onClose: () => {},
  };

  return BackdroppedView;
};

export default withBackdrop;
